import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  padding: 80px 30px;
  color: #fff;
  min-height: 100vh;
  background-color: #1a1a1a;
`;

export const Header = styled.div`
  margin-bottom: 30px;
  h1 {
    font-size: 28px;
    color: #b17d2a;
    margin-bottom: 10px;
  }
  p {
    color: #a9a9a9;
  }
`;

export const FilterSection = styled.div`
  background: #242424;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  align-items: end;
  border: 1px solid #333;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  label {
    font-size: 12px;
    color: #b17d2a;
    font-weight: bold;
    text-transform: uppercase;
  }
  input {
    background: #1a1a1a;
    border: 1px solid #444;
    padding: 10px;
    border-radius: 4px;
    color: white;
    outline: none;
    &:focus {
      border-color: #b17d2a;
    }
  }
`;

export const ActionButton = styled.button`
  background: #b17d2a;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    background: #d49a3f;
  }
`;

export const TableContainer = styled.div`
  background: #242424;
  border-radius: 8px;
  overflow-x: auto;
  border: 1px solid #333;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  th,
  td {
    padding: 15px;
    border-bottom: 1px solid #333;
    white-space: nowrap;
  }
  th {
    color: #b17d2a;
    font-size: 13px;
    text-transform: uppercase;
  }
  tr:hover {
    background: #2a2a2a;
  }
`;

export const VipBadge = styled.span`
  background: rgba(177, 125, 42, 0.2);
  color: #b17d2a;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  border: 1px solid #b17d2a;
`;

export const Pagination = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
  button {
    background: #242424;
    color: white;
    border: 1px solid #444;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
    &.active {
      background: #b17d2a;
      border-color: #b17d2a;
    }
  }
`;

const shimmer = keyframes`
  0% { background-position: -468px 0; }
  100% { background-position: 468px 0; }
`;

export const SkeletonRow = styled.tr`
  td {
    padding: 15px;
  }
`;

export const SkeletonCell = styled.div`
  width: ${props => props.width || "100%"};
  height: ${props => props.height || "20px"};
  background: #2a2a2a;
  background-image: linear-gradient(
    to right,
    #2a2a2a 0%,
    #333333 20%,
    #2a2a2a 40%,
    #2a2a2a 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 104px;
  display: inline-block;
  position: relative;
  animation: ${shimmer} 1.2s linear infinite forwards;
  border-radius: 4px;
`;

export const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  color: #a9a9a9;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    font-size: 40px;
    color: #333;
  }
`;
